export default "__VITE_ASSET__CJCiliq$__"